export const BASE_URL = process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS
export const AA_BASE_URL = process.env.LOCAL_AA_SERVER_FULL_ADDRESS
export const BASE_URL_ADMIN = process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS_ADMIN

export const EP_USER_PAN_ATTEMPT_NAME_API = '/api/pancard-fetch-digio'
export const EP_USER_PAN_ATTEMPT_DIGITAP_API = '/api/digitap/pan_details'

export const EP_PLEDGE_APPROVED_ISINS = '/api/marginpledge/approved/isins'
export const EP_MARGIN_PLEDGE_REQUEST = '/api/marginpledge/request'

export const EP_GET_BANK_INFORMATION_IN_DETAIL = '/api/get/bankdetail/from/sheet'


export const EP_CHECK_ACCOUNT_DETAIL = '/api/user/financial/statement'

export const EP_CHECK_DASHBOARD_STATS = '/api/dashboard/stats' //dashboard stats

export const EP_USER_FUNCTION = '/user/enter/manually'

export const EP_SET_FINANCIAL_LEDGER_LIST1 = '/api/ksoft/client/combined/fin/ledger'
export const EP_SET_TAX_REPORT_LIST1 = '/api/ksoft/client/long/short/term'

export const EP_ADD_GEOLOCATION = '/api/add/geoLocation/inFile'
//------------------------------------------------------Add API---------------------------------------------------------------
export const EP_ADD_SUPPORT_DATA = '/api/create/ticket'
export const EP_REPLY_SUPPORT_DATA = '/api/create/ticket/thread'
export const EP_ADD_ESIGN_ADHAR_DATA = '/api/esign/ticket/request'
export const EP_ADD_PAYIN_DATA = '/api/service/payment'
export const EP_ADD_COMPLAINT_DATA = '/api/service/otp/request'

export const EP_BAKSTAGED_TICKET = '/api/backstaged/ticket/thread'
//------------------------------------------------------Add OTP --------------------------------------------------------------
//export const EP_ADD_POA_BRACKET_REQUEST_DATA = '/api/service/request/poa/bracket'
export const EP_ADD_SERVICE_REQUEST_CHANGE_DATA = '/api/service/request'
export const EP_ADD_SERVICE_REQUEST_LEVERAGE = '/api/service/request/leverage'
export const EP_ADD_ESIGN_KYC_ADHAR_DATA = '/user/esign/kyc'
// export const EP_ADD_ESIGN_KYC_ADHAR_DATA = '/api/digio/esign-requests'

export const EP_MARGIN_PLEDGE_REQUEST_DETAIL = '/api/marginpledge/request/detail'


export const EP_KSOFT_PROFILE_API = '/api/ksoft/profile/data'

export const EP_MARGIN_PLEDGE_SUCCESS_ISIN = '/api/marginpledge/success/isins'
export const EP_POSITION_KSOFT_HOLDING_ORDER_LIST = '/api/ksoft/holding/data'
export const EP_GET_KSOFT_TAX_REPORT_LISTING = '/api/get/ksoft/tax/report'

//------------------------------------------------------List API--------------------------------------------------------------
export const EP_GET_POSITION_HOLDING_ORDER_LISTINGs = '/api/rising/dashboard/data'    //'/get/data'
export const EP_GET_SUPPORT_LISTING = '/api/list/tickets'
export const EP_GET_PROFILE_LISTING = '/api/get/profile'
export const EP_GET_DEPOSIT_LISTING = '/api/list/deposits'
export const EP_GET_FINANCIAL_LEDGER_LISTING = '/api/get/financial/ledger'
export const EP_GET_TAX_REPORT_LISTING = '/api/get/tax/report'
export const EP_FETCH_FAQ_LIST = '/api/blog/categories-prism'



export const EP_GET_CONTRACT_NOTE_LISTING = '/api/contract/notes'
export const EP_GET_TRADE_CONFIRMATION_LISTING = '/api/trade/confirmation'
export const EP_GET_CLOSE_POSITION_LISTING = '/api/get/closed/positions'
//------------------------------------------funds------------------------------------------------------
export const EP_GET_PORTFOLIO_LIST = '/api/mf/portfolios'
export const EP_GET_MANDATE_LIST = '/api/mf/mandate/info/list'

//------------------------------------------------------View API--------------------------------------------------------------
export const EP_VIEW_SUPPORT_DETAIL = '/api/view/tickets'
//--------------------------------------------------dropdown------------------------------------------------------------------
export const EP_GET_SUPPORT_REASON_LISTING = '/api/ticket/reasons'

export const EP_GET_CURRENT_LEVERAGE = '/api/service/get/leverage'

export const EP_CONFIRM_UPDATE_DATA = '/api/confirm/update/request/email'

export const EP_ADD_PROFILE_IMAGE_DATA = '/api/add/profile/image'

export const EP_GET_PLATFORM_LIST = '/api/get/platform/listing'

export const EP_GET_PCR_LEDGER_DATA = '/get/pcr/ledger'

export const EP_RESEND_OTP_DATA = '/api/otp/resend'

export const GET_REASON_WISE_TICKET = '/api/check/users/request'

export const EP_NEST_USER_DATA = '/api/rising/dashboard/data'

export const EP_MCX_NCDEX = '/user/mcx/category/declaration/otp'
export const EP_CLIENT_CONSENT = '/api/service/consent/create-ticket'
export const EP_MCX_NCDEX_OTP = '/user/mcx/category/declaration'
export const EP_GET_CATEGORIZATION = '/user/get/mcx/category/declaration'

export const EP_CREATE_MANDATE = '/api/mf/mandate/create' 

export const EP_PORTFOLIO_PAY = '/api/mf/pay/now'

export const EP_GET_IB_LIST = '/api/ib/list'

//===================coupon-module=================================
export const EP_GET_COUPON_LIST		=	'/api/coupon/list'
export const EP_COUPON_SCRATCH		=	'/api/coupon/scratch'
export const EP_COUPON_REEDEM		=	'/api/coupon/reedem'
export const EP_COUPON_REFERALL_MUTUAL_FUND = '/api/users/referral/mf'

export const EP_GET_MF_CHART_DATA	= 	'/api/mf/userportfoliochart'

//=========================change-password=========================
export const EP_CHANGE_PASSWORD		=	'/change/password'


export const EP_GET_CATALOG_PRODUCT_LIST  = '/admin/catalog/product/list'

export const EP_GET_CHECK_BALANCE  = '/admin/check/Balance'
export const EP_CREATE_ORDER  = '/admin/order/create'

export const EP_GET_ORDER_HISTORY_LIST  = '/admin/order/history'

export const EP_CHECK_ORDER_STATUS  = '/admin/order/status'

export const EP_ORDER_RESEND  = '/admin/order/resend'

export const EP_REFUND_BALANCE  = '/admin/order/refund'


//=================api key==================

export const EP_GET_GENERATE_API_KEY  = '/create_update/api/keys'
export const EP_GET_API_KEY_DETAIL  = '/get/api/keys/detail'


//=================nominee data==================
export const EP_GET_CLIENT_NOMINEE_DATA  = '/api/get/nominee/info'

// ================Digio=========================
export const EP_RUN_GET_DIGIO_DATA		=	 '/api/generate/request-id'
export const EP_RUN_SEND_DIGIO_DOC_DATA = 'api/digio/get-signed-document';
export const EP_RUN_SEND_DIGIO_DOC_KYC_DATA = '/api/digio/esign-webhook';

export const EP_FETCH_IPV_REDIRECT  = '/api/neobank/digio/initiate_frame';
export const EP_FETCH_AGGREGATOR_HEALTH = '/account-aggregator/actuator/health';
export const EP_SET_AGGREGATOR_REDIRECT = '/account-aggregator/api/redirect';
export const EP_SET_AGGREGATOR_ATTEMPTS = '/api/attempt/account-aggregator';
export const EP_SET_AGGREGATOR_SKIP = '/api/aggragator/update/skip';

// ================AI model======================
export const EP_RUN_GET_VALID_SIGNATURE = '/api/verifysignature'
export const EP_RUN_AGGREGATOR_TICKET_SUBMIT = '/api/save/aggregator-data';

//=============HDFC Bank list=====================
export const EP_HDFC_TRANSACTIONS = '/api/hdfc/transaction-list';
export const EP_HDFC_VALIDATE_TRANSACTION = '/api/hdfc/validate-transaction';

//=============Reverse Penny testing=====================
export const EP_REVERSE_PENNY_DROP = '/api/reverse/penny-drop';
export const EP_REVERSE_PENNY_DROP_STATUS = '/api/reverse/penny-drop/get-detail';
export const EP_REVERSE_PENNY_DROP_NAME_MATCH = '/api/fuzzy-match';
export const EP_REVERSE_PENNY_DROP_ATTEMPT = '/api/reverse/penny-attempt';
export const EP_REVERSE_PENNY_DROP_CHANGE_BANK_ACCOUNT = '/api/reverse/penny-drop/choose-another-bank';

export const EP_GET_SDK_INVOKE_DATA =  '/api/v2/reactivate-account/status'

export const EP_CHECK_GROSS_ANNUAL_INCOME_STATUS = '/api/check/gross-income-detail'
export const EP_SAVE_GROSS_ANNUAL_INCOME_DETAIL  = '/api/save/gross-income-detail'



// WEBPACK FOOTER //
// ./src/store/api/endpoints.js